import { useState } from "react";
import { Text } from "react-native";
import { useFormsStore } from "../../../../stores/onboarding"
import { usePersonalStore } from "../../../../stores/personalInfo"
import { useInitializeStore } from "../../../../stores/initialize"
import Toast from "react-native-toast-message"
import { globalStyles } from "../../../../static/styles/global"
import { ActivityIndicator, ScrollView, View } from "react-native"
import HomeDetailsHeader from "../../../home/HomeDetailsHeader"
import Card from "../../../shared/card/Card"
import moment from "moment"
import Canvas from "../../../canvas"
import CustomButton from "../../../shared/button/Button"


const RobertsAcknowledgement = ({ navigation, route }) => {
    const { essUserOnBoardingKey, essFormKey, essUserOnBoardingFormKey } = route.params
    const { loading, postrobertsverification, downloadFile } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState()
    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const [bandSafety, setBandSafety] = useState(false);
    const [meatSafety, setMeatSafety] = useState(false);
    const [employeeHandBook, setEmployeeHandBook] = useState(false);
    const [ccSecurity, setCCSecurity] = useState(false);
    const [prohibitedItems, setProhibitedItems] = useState(false);
    const [dressCode, setDressCode] = useState(false);
    const [apperance, setApperace] = useState(false);
    const [drugConsent, setDrugConsent] = useState(false);
    const [tobaccoSales, setTobaccoSales] = useState(false);
    const [cashAccountability, setCashAccountability] = useState(false);
    const [ebtTraining, setEbtTraining] = useState(false);
    const [beerSales, setBeerSales] = useState(false);





    const data = {
        completeOnline: true,
        essUserKey: intializestore.initializeData.userkey,
        entityId: personalstore.personalData?.entityId,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        sign: signatureDataURL,
        bandSafety: Number(bandSafety),
        meatSafety: Number(meatSafety),
        employeeHandbook: Number(employeeHandBook),
        ccSecurity: Number(ccSecurity),
        prohibitedItems: Number(prohibitedItems),
        dressCode: Number(dressCode),
        apCheck: Number(apperance),
        drugTest: Number(drugConsent),
        tobaccoSales: Number(tobaccoSales),
        caPolicy: Number(cashAccountability),
        ebtTraining: Number(ebtTraining),
        bWsales: Number(beerSales)
    }

    const handlesubmit = async () => {
        const response = await postrobertsverification(data)
        if (response?.success) {
            await Toast.show({
                type: "success",
                position: "bottom",
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: "error",
                position: "bottom",
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title="Robert's Acknowledgement"
                    />

                </View>
                <View style={{ borderColor: "white", borderStyle: "dashed", borderWidth: 2, padding: 5, margin: 5 }}>
                    <Text style={{ textAlign: "center", fontWeight: 'bold', color: 'white' }} >*** INSTRUCTIONS: Click on your name above to view the “Employee Onboarding Resources” section of the main menu. Please review all forms before making acknowledgments below. ***</Text>
                </View>
            </View>
            <ScrollView>
                <Card style={{
                    fontFamily: "Arial,sans-serif",
                    lineHeight: "1.6",
                    fontSize: "11px"
                }}>

                    <h3 style={{ textAlign: "center" }}>
                        Robert's Employee Document Review and Verification Form
                    </h3>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={bandSafety} onChange={(e) => setBandSafety(!bandSafety)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Band Saw Safety”
                                document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={meatSafety} onChange={(e) => setMeatSafety(!meatSafety)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Meat Cutter
                                Safety” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={employeeHandBook} onChange={(e) => setEmployeeHandBook(!employeeHandBook)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Employee
                                Handbook” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={ccSecurity} onChange={(e) => setCCSecurity(!ccSecurity)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Credit Card
                                Security Basics” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={prohibitedItems} onChange={(e) => setProhibitedItems(!prohibitedItems)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Prohibited Items”
                                document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={dressCode} onChange={(e) => setDressCode(!dressCode)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Dress Code”
                                document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={apperance} onChange={(e) => setApperace(!apperance)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Appearance
                                Standard” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={drugConsent} onChange={(e) => setDrugConsent(!drugConsent)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Consent to Drug
                                Testing” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={tobaccoSales} onChange={(e) => setTobaccoSales(!tobaccoSales)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Tobacco Sales
                                Policy” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={cashAccountability} onChange={(e) => setCashAccountability(!cashAccountability)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Cash
                                Accountability Policy” document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={ebtTraining} onChange={(e) => setEbtTraining(!ebtTraining)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “EBT Training”
                                document found in the employee resources section.
                            </p>
                        </div>
                        <div style={{ margin: "2px", display: "inline-flex" }}>
                            <input type="checkbox" style={{ margin: "5px" }} checked={beerSales} onChange={(e) => setBeerSales(!beerSales)} />
                            <p>
                                I have reviewed in its entirety and understand the content of the “Beer & Wine Sales
                                Policy” document found in the employee resources section.
                            </p>
                        </div>
                        <p>
                            By signing below, I acknowledge that I read and understand all the
                            information in the documents that I have selected above. I understand
                            that I can access these documents under the Employee Resources section
                            of the Workhappy menu.
                        </p>
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tr>
                            <td style={{ width: "80%", }}>
                                <p>
                                    <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} /><br />
                                    Employee Signature
                                    <br />
                                </p>
                            </td>
                            <td style={{ width: "20%" }}>
                                <span><u>{moment().format("MM/DD/YYYY")}</u></span><br />
                                <span>Date Signed</span> <br />
                            </td>
                        </tr>
                    </table>
                </Card>
                {loading ? <ActivityIndicator /> :
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('OnboardingForms')
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>}

            </ScrollView >
        </>
    )
}

export default RobertsAcknowledgement
